import React from "react"

const ApiStatusContext = React.createContext({})

const { Provider, Consumer } = ApiStatusContext

export { Provider, Consumer, ApiStatusContext }
